import Modal from '../_bootstrapModalExtensions';
import Interfaces from '../_interfaces';

export function FetchSummary(event: JQuery.TriggeredEvent) {
    const $btn: JQuery<HTMLElement> = $(event.currentTarget);
    const startDate: string = $('#start-date').val() as string;
    const endDate: string = $('#end-date').val() as string;
    const areaId: number = $('#areaSelector').val() as number ?? 0;

    if (!startDate || !endDate) {
        Modal.showAlertWindow('Kérjük, mindkét dátumot adja meg!', 'Hiányzó adat', 'Bezárás', false);
        return;
    }

    $btn.prop('disabled', true);

    $.ajax({
        url: window.ETDR_RD.appConfig['UrlAction.GetKsh1081SummaryData'],
        method: 'GET',
        data: { fromDate: startDate, toDate: endDate, areaId: areaId },
        success: (data: Interfaces.Ksh1081Summary) => {
            if (data) {
                fillSummaryTableCells(data);
            }
            else {
                Modal.showAlertWindow('Üres válasz érkezett', 'Hiba történt', 'Bezárás', false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow('Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!', 'Hiba történt', 'Bezárás', false);
        },
        complete: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus) => {
            $btn.prop('disabled', false);
        }
    });
}

function fillSummaryTableCells(data: Interfaces.Ksh1081Summary) {
    $('#bp-count').text(data.BuildingPermitCount);
    $('#bp-building-count').text(data.BuildingPermitBuildingCount);
    $('#bp-flat-count').text(data.BuildingPermitFlatCount);
    $('#spn-count').text(data.NewBuildingSimpleProcessCount);
    $('#spn-building-count').text(data.NewBuildingSimpleProcessBuildingCount);
    $('#spn-flat-count').text(data.NewBuildingSimpleProcessFlatCount);
    $('#spe-count').text(data.BuildingExpansionSimpleProcessCount);
    $('#spe-flat-count').text(data.BuildingExpansionSimpleProcessFlatCount);
}

$(document).on('click', '#ksh-summary-fetch-btn', (event: JQuery.TriggeredEvent) => {
    FetchSummary(event);
});
